import React from 'react';
import { styled } from '@compiled/react';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { Illustration } from '@atlassian/jira-illustration/src/ui/index.tsx';
import {
	srcLight,
	srcDark,
} from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/objects/components/folder/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export const ProjectNotificationsEmptyState = () => {
	const { formatMessage } = useIntl();
	return (
		<Box xcss={emptyProjectsBoxStyles}>
			<Flex>
				<Illustration
					width="100"
					srcLight={srcLight}
					srcDark={srcDark}
					alt="Choose a project to get started"
				/>
				<Box xcss={emptyProjectsBoxDescriptionStyles}>
					<SectionHeading>
						{formatMessage(messages.notificationProjectSettingsEmptyProjectsBannerTitle)}
					</SectionHeading>
					<ProjectSectionDescription>
						{formatMessage(messages.notificationProjectSettingsEmptyProjectsBannerBodyText)}
					</ProjectSectionDescription>
				</Box>
			</Flex>
		</Box>
	);
};

const emptyProjectsBoxStyles = xcss({
	borderColor: 'color.border',
	borderStyle: 'solid',
	borderRadius: 'border.radius',
	borderWidth: 'border.width',
	padding: 'space.200',
	paddingInline: 'space.400',
	backgroundColor: 'elevation.surface.sunken',
});

const emptyProjectsBoxDescriptionStyles = xcss({
	marginLeft: 'space.500',
	marginTop: 'space.400',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ProjectSectionDescription = styled.p({
	marginBottom: token('space.300'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SectionHeading = styled.h5({
	marginBottom: token('space.200'),
});
